import React from 'react';
import Modal from './Modal';
import Button from './Button.js';
import { connect } from 'react-redux';
import { getDressToolFlagData } from '../../refresh/selectors/braRecommedation';
import {
  showModal as showDressToolModal,
  hideModal as hideDressToolModal
} from '../../actions/modal';
import { getDressToolAtcPopupConfig } from '../../refresh/selectors/featureFlagsSelector';
import {  dressToolWithoutFirstStep } from '../../actions/shared/braRecommendation';
import properties from '../../modules/ajio-util/properties';
import { replaceWithJioCDN } from '../../utils/imageHandling';


const DressToolATCModal = ({ showATCDressModal, hideATCDressModal, dressToolAtcPopupConfig,initiateWithoutFirstFlag }) => {
  const imageBaseUrl = properties.getProperty('imageBaseUrl');
  const ga4BannerName=(dressToolAtcPopupConfig && dressToolAtcPopupConfig?.bannerName ? dressToolAtcPopupConfig?.bannerName : 'add to cart');
  return (
    <div id="BraDressToolWrapper1">
      <Modal show name="dress-tool-atc-modal" className="dress-tool-modal-wrap">
        <div className="dress-tool-modal">
          <div className="modal-heading">
            <h1 className="tool-main-heading">{dressToolAtcPopupConfig && dressToolAtcPopupConfig?.title ? dressToolAtcPopupConfig?.title : "Woah! That’s a great choice!"}</h1>
            <h2 className="tool-sub-heading">{dressToolAtcPopupConfig && dressToolAtcPopupConfig?.subTitle ? dressToolAtcPopupConfig?.subTitle : "Need help finding a bra that pairs perfectly with this dress? We are here to help!"}</h2>
          </div>
          <div className="selectionGridContainer">
          <img
              className="not-found__image img-responsive dressToolDesktopBanner"           //PDP Desktop banner initiation
              src={dressToolAtcPopupConfig && dressToolAtcPopupConfig?.imgUrl ? replaceWithJioCDN(dressToolAtcPopupConfig?.imgUrl) : ""}
              alt="AJIO Bra Genie"
              width="100%"
              onClick={() => {
                hideATCDressModal('dress-tool-atc-modal');
                showATCDressModal('dress-tool-modal');
                initiateWithoutFirstFlag();          //for dress tool
                sessionStorage.setItem('dressToolIngressDetails', JSON.stringify({IngressPoint:'add to cart', BannerName:ga4BannerName}));
              }}
            />
          </div>
        </div>
      </Modal>
    </div>
  );
};

const mapDispatchToProps = dispatch => {
  return {
    showATCDressModal: (name, config) => {
      dispatch(showDressToolModal(name, config));
    },
    initiateWithoutFirstFlag: () => dispatch(dressToolWithoutFirstStep()),
    hideATCDressModal: name => dispatch(hideDressToolModal(name))
  };
};

const mapStateToProps = state => {
  return {
    dressToolFlagReducer: getDressToolFlagData(state),
    dressToolAtcPopupConfig: getDressToolAtcPopupConfig(state)
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DressToolATCModal);
